<template>
  <div class="selector">
    <div class="selector-section">
      <!-- <h3>{{ categoryTitle }}</h3> -->
      
      <div class="selector-section-category">
        <button 
          v-for="(category, index) in categorys" 
          :key="index" 
          class="selector-section-category-item" 
          :class="!status ? '' : selectedCategory.type === category.type ? 'selector-section-category-item-active' : ''"
          :disabled="!status"
          style="position:relative"
          @click="$emit('changeCategory', category)"
        > 
          <InfoButton 
            v-if="category.infoboxIsOnline"
            @showspecs="infoboxDataEntry = category.infobox; enableAndHoldSpecs(index);"
          />
          <img :src="host + category.typeImage" alt="">
          <h4>{{ category.type }}</h4>
        </button>
      </div>
    </div>

    <div class="flexRow">
      <div 
        v-if="!(selectedCategory.id == '6622508ad0774fabfa45b6c6')" 
        class="selector-section"
      >
        <h3>Houtsoort</h3>
        <div v-for="houtsoort in groupedHoutsoorten" :key="houtsoort.id">
          <h2>{{ houtsoort.name }}</h2>

          <div class="selector-section-color">
            <button 
              v-for="(option, index) in houtsoort.colors" 
              :key="index"
              class="selector-section-color-item"
              :class="!status ? '' : option.name === selectedColor.name ? 'selector-section-color-item-active' : ''"
              :disabled="!status"
              @click="$emit('changeColor', option)"
            >
              <div class="selector-section-color-item-image">
                <img :src="host + option.previewURL" alt="">
              </div>
              <span class="selector-section-color-item-name">{{ option.name }}</span>
              <!-- <div class="selector-section-color-item-hover">
                <span class="selector-section-color-item-hover-name">{{ option.name }}</span>
              </div> -->
            </button>
          </div>
        </div>
      </div>
      <div 
        v-if="!(selectedCategory.id == '6622508ad0774fabfa45b6c6') && showThirdSection" 
        class="selector-section"
      >

        <!-- <div class="selector-section-color">
          <button 
            v-show="extraOptionIsTurnedOn"
            class="extra-option-toggle"
            @click="$emit('changeExtraOption', false)"
          >
            <img 
              :src="`${previewsServer}/textures/ui/${extraOptionOnGraphic}`" 
              height="50"
              width="150" 
            >
          </button>
          <button 
            v-show="!extraOptionIsTurnedOn"
            class="extra-option-toggle"
            @click="$emit('changeExtraOption', true)"
          >
            <img 
              :src="`${previewsServer}/textures/ui/${extraOptionOffGraphic}`" 
              height="50"
              width="150" 
            >
          </button>
        </div> -->
      </div>
    </div>
  </div>
  <Teleport to="body">
    <Transition name="fade">
      <div
        v-show="specsVisible"
        id="fullcoverForCategorySelector"
        tabindex="-1"
        @click="specsVisible = false"
        @keydown.escape="specsVisible = false"
      >              
        <div 
          :class="onMobile ? 'modalspecs modalspecs-size-mobile' : 'modalspecs modalspecs-size'"
          @click.stop=""
        >
          <button 
            class="modalclosebutton" 
            @mouseover="specsCloseBtnMouseOver" 
            @mouseleave="specsCloseBtnMouseLeave"
            @click="specsVisible = false"
          >
            <Transition name="closebtn">
              <div 
                v-show="hasGlowingCloseBtn"
                class="absolutepos glowingclose"
              />
            </Transition>
            <div>
              ×
            </div>
          </button>
          <div class="imagescroller">
            <img class="modalimage" :src="`/infoboximages/${getFullInfoboxData?.urlEnding}`" alt="">
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
  import { mapGetters } from 'vuex'
  import InfoButton from '@/components/inputs/buttons/InfoButton.vue'

  export default {
    components: {
      InfoButton
    },
    props: {
      categoryTitle: String,
      optionTitle: String,
      categorys: Array,
      status: Boolean,
      selectedCategory: Object,
      selectedColor: Object,
      // de bedoeling is dat "extraOption" hergebruikt kan worden voor verschillende onderwerpen.
      // momenteel is het in gebruik voor wand isolatie aan/uit knoppen in de UI.
      showThirdSection: Boolean,
      thirdSectionTitle: String,
      extraOptionIsTurnedOn: Boolean,
      extraOptionOffGraphic: String,
      extraOptionOnGraphic: String,
    },
    emits: ['changeCategory', 'changeColor', 'changeExtraOption'],
    data () {
      return {
        host: import.meta.env.VITE_VUE_APP_TEXTURE_LOCATION,
        previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER,
        onMobile: false,
        specsVisible: false,
        hasGlowingCloseBtn: false,
        infoboxDataEntry: null,
      }
    },    

    computed: {
      ...mapGetters({
        houtsoorten: 'getHoutsoortTypes',
        infoboxes: 'getInfoboxes'
      }),

      groupedHoutsoorten () {
        const availableHoutsoorten = []
        for (const color of this.selectedCategory.colors) {
          if (availableHoutsoorten.find(h => h.id === color.houtsoort)) {
            availableHoutsoorten.find(h => h.id === color.houtsoort).colors.push(color)
          } else {
            availableHoutsoorten.push({
              id: color.houtsoort,
              name: this.houtsoorten.find(h => h.id === color.houtsoort)?.name,
              colors: [color]
            })
          }
        }
        return availableHoutsoorten
      },

      getFullInfoboxData() {
        // console.log('infoboxes', this.infoboxes)
        return this.infoboxes.find(info => info.id === this.infoboxDataEntry?.id)
      }
    },
    created() {
      let regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      this.onMobile = regex.test(navigator.userAgent)
      this.$nextTick(() => {
          document.getElementById('fullcoverForCategorySelector')
            .addEventListener('click', function (/*event*/) {
                // console.log('TEST',event)
            });
        })
    },
    methods: {
      specsCloseBtnMouseOver() {
        this.hasGlowingCloseBtn = true;
      },
      specsCloseBtnMouseLeave(){
        this.hasGlowingCloseBtn = false;
      },
      enableAndHoldSpecs(index) {
        console.log('index',index, 'infoboxDataEntry', this.infoboxDataEntry)
        this.specsVisible = !this.specsVisible;
        if (this.specsVisible) {
          this.$nextTick(() => {
            document.getElementById('fullcoverForCategorySelector')?.focus();
          });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

.flexRow {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.extra-option-toggle {
  // border-style: none; 
  border: 3px solid white;
  border-radius: 2rem;
  background-color: transparent;//black;
  position: relative;
}

.togglegraphic {
  position: absolute;
  inset: 0px;
  margin-top: -0.4rem;
  border-style: solid;
  border: 3px solid white;
  border-radius:2rem;
}
.togglegraphic:hover {
  cursor: pointer;
  border-style: solid;
  border-color: $c-secondary; 
}

#fullcoverForCategorySelector {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}
.modalspecs {
  position: fixed;
  z-index: 999;
  left: 50%;
  background-color: white;
  border-radius: $radius-s;
}
.modalspecs-size {
    top: 3%;
    width: 36rem;
    margin-left: -18rem;
    height: 94vh;
 }
.modalspecs-size-mobile {
    top: 10%;
    width: 98%;
    margin-left: -49%;
    height: 80vh;
 }

.modaltopcontainer {
  display: flex; text-align: start; height: 8vh
}
.modaltopcontainer h3 {
  margin: 1.5vh 1.5vh 1.5vh 3vh;
}

.imagescroller {
  max-height: calc(98%);
  overflow-y: auto;
  border-radius: $radius-m;
}
.modalimage {
  width: 100%;
  height: auto;
}

.modalclosebutton {
  position: absolute;
  top: 32px;
  right: 48px;
  height: 4vh;
  width: 4vh;
  background: transparent;
  color: white;
  border: 2px solid white;
  box-sizing: border-box;
  border-radius: 3vh;
  font-size: 4vh;
  pointer-events: all;
  cursor: pointer;
  // force the × to stay centered despite resizing
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.5s ease;

  &:hover {
    background-color: rgba(255, 255, 15, 0.75);
  }
}

.glowingclose {
  border-radius: 20px;
}

.selector {
  display: flex;
  flex-direction: column;
  // padding-bottom: 15px;

  &-section {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    width: 100%;

    & h3 {
      text-align: left;
      margin: 0px;
      font-size: 20px;
      font-weight: 400;
      color: $c-primary;
      margin-top: 8px;
    }

    & h2 {
      text-align: left;
      margin: 0px;
      font-size: 12px;
      font-weight: 700;
      color: $c-primary;
      margin-bottom: 8px;
    }

    &-category {
      display: flex;
      gap: 16px;
      flex-wrap: wrap;

      &-item {
        width: 132px;
        display: inline-block;
        flex-direction: column;
        align-items: center;
        background-color: transparent;
        border: none;
        margin: 0px;
        padding: 0px;

        &-active {
          & img {
            border: 4px solid $c-secondary !important;
          }
          //background-color: $c-background-1;
        }

        &:hover:enabled {
          & img {
            border: 4px solid $c-secondary;
          }
          //background-color: $c-background-1;
          cursor: pointer;
        }

        &:disabled {
          cursor: not-allowed;
        }

        & h4 {
          font-size: 14px;
          font-weight: 400;
          margin: 0px;
        }

        & img {
          transition: background-color 100ms ease, border-color 100ms ease;
          width: 100%;
          object-fit: contain;
          border: 2px solid $c-border-1;
          border-radius: $radius-m;
          box-sizing: border-box;
        }
      }
    }

    &-color {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;

      &-item {
        width: 58px;
        border: none;
        background-color: transparent;
        display: inline-block;
        padding: 0px;
        cursor: pointer;
        position: relative;
        border-radius: $radius-s;
        outline: 4px solid transparent;
        outline-offset: -4px;
        transition: outline-color 100ms ease;
        display: flex;
        flex-direction: column;

        & div {
          transition: border 100ms;
        }

        // &-active {
        //   outline: 4px solid $c-secondary;
        // }

        &-active {
          & div {
            border: 4px solid $c-secondary;
          }
        }

        &-image {
          width: 58px;
          overflow: hidden;
          height: 58px;
          border-radius: $radius-m;
          border: 2px solid $c-border-1;
          box-sizing: border-box;
        }

        &-name {
          font-size: 9px;
          position: relative;
          left: 50%;
          transform: translateX(-50%);
        }

        & img {
          width: 100%;
          height: 100%;
          background-color: $c-background-1;
        }

        &:hover:enabled > .selector-section-color-item-hover {
          transform: translateY(-30px);
        }

        &:disabled {
          cursor: not-allowed;
        }

        &-hover {
          position: absolute;
          bottom: -30px;
          left: 0px;
          background-color: $c-transparent-1;
          width: 100%;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: $radius-s;
          transition: transform 175ms ease;

          &-name {
            font-weight: 500;
            font-size: 0.5rem;
            padding: 5px;
            color: white;
            text-align: center;
            max-width: 100%;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

</style>